module.exports = __webpack_public_path__ + "static/media/google_play.db04ff22.jpg";